module.exports = __webpack_public_path__ + "static/media/ill-start-by-opening-p2.99c1966a.jpg";